export default __webpack_public_path__ + "e0fe14c650ca02af88421c152ff9a10e.svg";